import { Inject, Injectable } from '@angular/core';
import {
	AccountInfo,
	AuthenticationResult,
	InteractionRequiredAuthError,
	RedirectRequest,
} from '@azure/msal-browser';
import { MSAL_GUARD_CONFIG, MsalGuardConfiguration, MsalService } from '@azure/msal-angular';
import { environment } from '@env/environment';
import { UserStore } from '@stores/user.store';

@Injectable({
	providedIn: 'root',
})
export class MsalAngularService {
	constructor(
		@Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
		private userStore: UserStore,
		private msalService: MsalService,
	) {}

	fnInit() {
		return new Promise<boolean>((resolve, reject) => {
			this.msalService.handleRedirectObservable().subscribe({
				next: async (authResult: AuthenticationResult) => {
					if (!this.activeAccount) {
						this.login();
						resolve(false);
					} else if (authResult) {
						this.setMsalData(authResult);
						resolve(true);
					} else {
						const success: boolean = await this.acquireTokenSilent();
						resolve(success);
					}
				},
				error: error => {
					resolve(false);
				},
			});
		});
	}

	acquireTokenSilent() {
		return new Promise<boolean>((resolve, reject) => {
			if (!this.activeAccount) {
				resolve(false);
				return;
			}

			// console.log('acquire new token');
			this.msalService.instance
				.acquireTokenSilent({
					scopes: [environment.msalConfig.accessAPI, 'user.read'],
					account: this.activeAccount,
				})
				.then(
					(authResult: AuthenticationResult) => {
						this.setMsalData(authResult);
						resolve(true);
					},
					error => {
						if (error instanceof InteractionRequiredAuthError) this.login();
						resolve(false);
					},
				);
		});
	}

	redirectToProfile() {
		const loginHint = '&login_hint=' + this.userStore.getUser().email;
		const tenantId = '&tid=' + environment.msalConfig.authority;
		window.open(environment.msalConfig.profileUrl + loginHint + tenantId, '_blank');
	}

	setMsalData(authResult: AuthenticationResult): void {
		this.userStore.updateUser({
			token: authResult.accessToken,
			azureId: authResult.uniqueId,
		});
	}

	login(): void {
		this.msalService.loginRedirect({
			...this.msalGuardConfig.authRequest,
		} as RedirectRequest);
	}

	logout(): void {
		this.msalService.logoutRedirect({
			authority: environment.msalConfig.authority,
			account: this.activeAccount,
			postLogoutRedirectUri: environment.msalConfig.redirectUri + '/home',
		});
	}

	get activeAccount(): AccountInfo | undefined {
		const accounts = this.msalService.instance.getAllAccounts();

		if (!accounts || accounts.length === 0) {
			return undefined;
		}

		return accounts.find(account => {
			return account.username.toLowerCase().includes(environment.msalConfig.emailSuffix);
		});
	}
}
